'use client'
import { getStore } from '../../store.js';

const setNetworkConfigurations = (networkConfigurations) => getStore().setState({ networkConfigurations });

export { setNetworkConfigurations };
